var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.isFeatureEnabled
    ? _c(
        "div",
        {
          staticClass: "canvas-toolbar-top",
          class: { "pre-merge-height": _setup.isPreMergeFlow },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "toolbar-container d-flex justify-content-center align-items-center",
            },
            [
              _c(_setup.CanvasToolbarTopPreviewButtons),
              _vm._v(" "),
              _setup.canModifyPreview
                ? _c(
                    "div",
                    [
                      _c(_setup.CButton, {
                        directives: [{ name: "tippy", rawName: "v-tippy" }],
                        staticClass: "add-button",
                        attrs: {
                          content: "Add preview",
                          size: "icon",
                          icon: ["far", "plus"],
                          variant: "secondary",
                        },
                        on: { click: _setup.onAddPreview },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }